<app-breadcrumb [crumbPaths]="[{
    name: 'Home',
    path: '/home'
}, {
    name: 'Broker Admin',
    path: '/broker-admin',
    active: true
}]"></app-breadcrumb>
<app-page-header title="Broker Admin" [buttons]="[{
        name: 'Add',
        eventName: 'add',
        cssClass: 'bg-primary'
    }]" (onButtonClick)="action($event)">
</app-page-header>
<app-page-content>
    <app-data-grid [dataSource]="dataSource" [config]="config" [dataLength]="dataSource.length" [isLoading]="isLoading"
        (dataActionEvent)="action($event)">
    </app-data-grid>
</app-page-content>

<app-slide-panel title="{{ this.editSelected ? 'Edit' : 'Add' }}" [(visible)]="addPanel" *ngIf="addPanel">
    <app-broker-admin-add [user]="editSelected" (onDone)="onPopupclose()">
    </app-broker-admin-add>
</app-slide-panel>